import { styled } from "../../theme";

export const Container = styled.div`
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TextTitleContainer = styled.div`
  min-height: 10%;
  align-self: flex-start;
  padding-top: 1em;
  .title_level_2 {
    text-transform: uppercase;
    color: ${({ theme }) => theme.color.primary};
    text-align: left;
    padding-left: 2em;
    padding-bottom: 0.2em;
    border-bottom: 0.2em ${({ theme }) => theme.color.primary} solid;
    @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
      padding-left: 1em;
    }
  }
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    min-height: 3em;
    position: relative;
    font-size: 0.9em;
    padding-top: 5em;
    padding-bottom: 2em;
    max-width: 90%;
  }
`;
